// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `rails generate channel` command.
//=require self

import { createConsumer } from "@rails/actioncable"

// Singleton guard: ensure only one consumer per browser context.
if (!window.__acConsumer) {
  window.__acConsumer = createConsumer()
  if (window && window.console) {
    console.log("[ActionCable] consumer created", new Date().toISOString())
  }
} else {
  // Optional debug hook to spot unexpected re-imports.
  if (window && window.console) {
    console.log("[ActionCable] consumer reuse", new Date().toISOString())
  }
}

export default window.__acConsumer

// Optional: hook Turbo to disconnect before cache to avoid zombie sockets during back/forward cache restores.
document.addEventListener("turbo:before-cache", () => {
  // Do not fully close; preserving connection improves live reporting continuity.
  // Left intentionally noop; add logic here if you later decide to pause.
})
